/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from "react";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import Table from "@mui/joy/Table";
import Sheet from "@mui/joy/Sheet";
import IconButton from "@mui/joy/IconButton";
import ApprovalIcon from "@mui/icons-material/Approval";
import Typography from "@mui/joy/Typography";
import Chip from "@mui/joy/Chip";
import CircularProgress from "@mui/joy/CircularProgress"; // Import CircularProgress
import Checkbox from '@mui/joy/Checkbox';

import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { Autocomplete } from "@mui/joy";
import DownloadIcon from '@mui/icons-material/Download';

import { useNavigate } from "react-router-dom";
import { apiBaseUrl, invoiceStatusOptionsEmployee } from "../utils/constants";
import { OrderTableProps, InvoiceEntry, CombinedSearchInvoiceEntry } from "../utils/types";
import {
  useGetAgreedAndForwardMultipleMutation,
  useGetEmployeeDetailsODataQuery,
  useGetEmployeeInvoicesQuery,
  useGetEmployeeListNewQuery,
  useGetEmployeePendingInvoicesQuery,
  useSearchEmployeeInvoicesQuery,
  useSoftDeleteInvoiceMutation,

  useGetSearchMyRequestSearchQuery,
  useGetApprovalPendingSearchQuery
} from "../services/invoices/InvoiceApiSlice";
import MultiSelectCheckboxDropdown from "../components/MultiSelectCheckdownDropbox";
import { toast } from "react-toastify";
import { DateRange } from "@mui/icons-material";
import { displayOptional } from "../utils/utils";
import ClearIcon from '@mui/icons-material/Clear';

type Order = "asc" | "desc";

const ITEMS_PER_PAGE = 10;


// --- Helper functions remain unchanged ---
const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) return "N/A";
  // try {
  //   const date = new Date(dateString);
  //   if (isNaN(date.getTime())) return dateString;
  //   return date.toLocaleDateString(undefined, {
  //     year: "numeric",
  //     month: "short",
  //     day: "numeric",
  //   });
  // } catch (e) {
  //   return dateString;
  // }
  const date = new Date(dateString);
  return String(date.getDate()).padStart(2, '0') + "-" + String(date.getMonth() + 1).padStart(2, '0') + "-" + date.getFullYear();
};

export default function EmployeeInvoicesTable({ isPendingPage }: OrderTableProps) {
  const navigate = useNavigate();

  const tableHeaders: Array<{
    id: keyof InvoiceEntry | "action" | "req_type";
    label: string;
    minWidth: number;
    numeric?: boolean;
    disableSort?: boolean;
  }> = [
      { id: "bts_no", label: "BTS No.", minWidth: 130 },
      { id: "vendor_name", label: "Vendor Name", minWidth: 130 },
      { id: "vendor_code", label: "Vendor Code", minWidth: 130 },
      { id: "bts_entry_date", label: "Entry Date", minWidth: 110 },
      { id: "po_no", label: "PO/Contract", minWidth: 130 },
      { id: "bill_no", label: "Bill No.", minWidth: 110 },
      { id: "req_type", label: "Request Type", minWidth: 130 },
      ...(!isPendingPage
        ? [
          {
            id: "invoicenumber" as keyof InvoiceEntry,
            label: "Inv/Ref No.",
            minWidth: 150,
          },
        ]
        : []),
      { id: "bill_date", label: "Invoice Date", minWidth: 110 },
      { id: "tax_amount", label: "Tax Amt.", minWidth: 70, numeric: true },
      { id: "bill_amount", label: "Invoice Amt.", minWidth: 130, numeric: true },
      { id: "status", label: "Status", minWidth: 130 },
      { id: "action", label: "Action", minWidth: 120, disableSort: true },
    ];

  // ===================================================================
  // === 1. ALL HOOKS ARE CALLED AT THE TOP, UNCONDITIONALLY         ===
  // ===================================================================
  const [openFilterModal, setOpenFilterModal] = React.useState(false);
  const [deleteModalId, setDeleteModalId] = React.useState<number | string>();

  const [isForward, setIsForward] = React.useState<any>(false);
  const [forwardTo, setForwardTo] = React.useState<any>('');
  const [currentPage, setCurrentPage] = React.useState(1);
  const [selectedList, setSelectedList] = React.useState([]);
  const [order, setOrder] = React.useState<Order>("desc");
  const [orderBy, setOrderBy] = React.useState<keyof InvoiceEntry | keyof CombinedSearchInvoiceEntry>("bts_entry_date");
  const [filterInputs, setFilterInputs] = React.useState({
    bts_no: "",
    po_no: "",
    invoice_status: [] as string[],
    vendor_code: "",
    vendor_name: "",
    bill_date: "",
  });

  const [gemInvoiceList, setGemInvoiceList] = React.useState([]);
  const { data: GEMInvoicesdata } = useGetEmployeeListNewQuery(null);
  // const { data: GEMInvoicesdata } = useGetEmployeeDetailsODataQuery(0);
  const [softDeleteInvoice, { isLoading: deleteInprogress }] = useSoftDeleteInvoiceMutation();
  const [agreedandforwardSelectedList, { isLoading: isForwarding }] = useGetAgreedAndForwardMultipleMutation();

  const clearFilter = () => {
    setFilterInputs({ bts_no: "", po_no: "", invoice_status: [] as string[], vendor_code: "", vendor_name: "", bill_date: "" });
  };


  React.useEffect(() => {

    if (GEMInvoicesdata?.d?.results) {
      var temp: any = [];
      var list: any = [];
      GEMInvoicesdata?.d?.results.map((item: any) => {
        if (temp.indexOf(item.ename) === -1) {
          temp.push(item.ename);
          // list.push({ label: item.ename + ` (${item.pernr})`, ...item })
          list.push({ label: `${item?.ename} - ${item?.pernr} - ${item?.position_txt} - ${item?.persa_txt} - ${item?.btrtl_txt}`, ...item })
          return;
        }

      })
      setGemInvoiceList([...list]);
    }
  }, [GEMInvoicesdata])


  React.useEffect(() => {
    clearFilter();
  }, [isPendingPage]);
  const [debouncedFilters, setDebouncedFilters] = React.useState(filterInputs);
  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedFilters(filterInputs);
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [filterInputs]);

  const {
    data: allInvoices,
    error: errorAllInvoices,
    isLoading: loadingAllInvoices,
    isFetching: fetchingAllInvoices,
  } = useGetEmployeeInvoicesQuery(
    { page: currentPage, per_page: ITEMS_PER_PAGE },
    { skip: isPendingPage, refetchOnMountOrArgChange: true } // Skip this hook when pending page is active
  );

  const {
    data: pendingInvoices,
    error: errorPendingInvoices,
    isLoading: loadingPendingInvoices,
    isFetching: fetchingPendingInvoices,
  } = useGetEmployeePendingInvoicesQuery(
    { page: currentPage, per_page: ITEMS_PER_PAGE },
    { skip: !isPendingPage, refetchOnMountOrArgChange: true } // Skip this hook when it's not pending
  );

  // Now choose the correct result set:
  const data = isPendingPage ? pendingInvoices : allInvoices;
  const errorEmployeeInvoices = isPendingPage ? errorPendingInvoices : errorAllInvoices;
  const loadingEmployeeInvoices = isPendingPage ? loadingPendingInvoices : loadingAllInvoices;
  const isFetching = isPendingPage ? fetchingPendingInvoices : fetchingAllInvoices;

  // const [debouncedFilterInputs, setDebouncedFilterInputs] = React.useState(filterInputs);

  const isSearchActive = React.useMemo(
    () =>
      !!(
        debouncedFilters.bts_no ||
        debouncedFilters.po_no ||
        debouncedFilters.invoice_status.length > 0 ||
        debouncedFilters.vendor_name ||
        debouncedFilters.vendor_code ||
        debouncedFilters.bill_date
      ),
    [debouncedFilters]
  );

  const searchApiArgs = {
    bts_no: debouncedFilters.bts_no,
    po_no: debouncedFilters.po_no,
    vendor_name: debouncedFilters.vendor_name,
    vendor_code: debouncedFilters.vendor_code,
    bill_date: debouncedFilters.bill_date,
    status: debouncedFilters.invoice_status.join(","),
    approval_pending: isPendingPage
  };

  // const {
  //   data: searchResults,
  //   isLoading: isLoadingSearch,
  //   isFetching: isFetchingSearch,
  // } = useSearchEmployeeInvoicesQuery(searchApiArgs, {
  //   skip: !isSearchActive,
  // });

  const {
    data: searchResults1,
    isLoading: isLoadingSearch1,
    isFetching: isFetchingSearch1,
  } = useGetApprovalPendingSearchQuery({ ...searchApiArgs, page: currentPage, per_page: ITEMS_PER_PAGE }, {
    skip: (!isSearchActive || !isPendingPage),
  });

  const {
    data: searchResults2,
    isLoading: isLoadingSearch2,
    isFetching: isFetchingSearch2,
  } = useGetSearchMyRequestSearchQuery({ ...searchApiArgs, page: currentPage, per_page: ITEMS_PER_PAGE }, {
    skip: (!isSearchActive || isPendingPage),
  });

  var searchResults = isPendingPage ? searchResults1 : searchResults2;
  var isLoadingSearch = isPendingPage ? isLoadingSearch1 : isLoadingSearch2;
  var isFetchingSearch = isPendingPage ? isFetchingSearch1 : isFetchingSearch2;


  const onHandleChangeRow = (btnNo: any, target: any) => {
    let temp = [...selectedList];
    if (target.checked) {
      temp.push(btnNo);
      setSelectedList([...temp]);
    } else {
      let temp1 = temp.filter((item) => item !== btnNo);
      setSelectedList([...temp1]);
    }
  }
  const onHandleCheckUnCheckAll = (target: any) => {
    let temp = [];
    const displayedData = data;
    const entrie = isSearchActive ? searchResults?.data?.entries : displayedData?.entries || [];
    if (target.checked) {
      entrie?.map((item: any) => temp.push(item?.bts_no));
    }
    setSelectedList([...temp]);
  }


  const onHendleSendSelectedList = async () => {
    try {

      let payload = selectedList?.map((item) => ({ bts_no: item, perner: forwardTo?.pernr.trim(), perner_name: forwardTo?.ename, user_id: localStorage.getItem("employee_id"), user_name: localStorage.getItem("employee_name") }))
      const response: any = await agreedandforwardSelectedList([...payload]);
      if (response?.data?.message) {
        toast.success(response?.data?.message)
      } else {
        toast.error(response?.error?.data?.message)
      }
      setForwardTo('');
      setIsForward(false);
      setSelectedList([]);
    } catch (err) {
      let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
      toast.error(errorMessage);
    }
  }


  // ===================================================================
  // === 2. HANDLE LOADING AND ERROR STATES *AFTER* ALL HOOKS        ===
  // ===================================================================
  if (loadingEmployeeInvoices && !isSearchActive) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (errorEmployeeInvoices) {
    return (
      <Typography color="danger" sx={{ p: 4, textAlign: "center" }}>
        Error loading data.
      </Typography>
    );
  }

  // ===================================================================
  // === 3. SAFELY ACCESS DATA AND DEFINE HANDLERS                   ===
  // ===================================================================

  // Safely destructure data with fallback defaults to prevent crashes
  const displayedData = data;
  const entries = isSearchActive ? searchResults?.data?.entries : displayedData?.entries || [];
  const pagination = isSearchActive ? searchResults?.data?.pagination : displayedData.pagination;
  // const isLoading = isSearchActive ? isLoadingSearch : loadingEmployeeInvoices;
  const isLoading = loadingEmployeeInvoices;
  // const isFetchingData = isSearchActive ? isFetchingSearch : isFetching;

  const handleSort = (property: keyof InvoiceEntry | keyof CombinedSearchInvoiceEntry) => {
    const header = tableHeaders.find((h) => h.id === property);
    if (header?.disableSort) return;
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setCurrentPage(1);
  };
  //  const handleView = (invoiceId: number | string) => { /* Your logic here */};
  // const handleEdit = (invoiceId: number | string) => { /* Your logic here */};
  const handleDelete = async (invoiceId: number | string) => {
    if (!invoiceId) {
      console.error("No invoice ID provided to delete.");
      return;
    }
    try {
      const response = await softDeleteInvoice({
        invoice_id: String(invoiceId),
      }).unwrap();
      // const response = await softDeleteInvoice({
      //   invoice_id: Number(extractInvoiceNumberWithRegex(invoiceId)),
      // }).unwrap();

      setDeleteModalId(null);
      //   refetchInvoices();
    } catch (err) {
      let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
      toast.error(errorMessage);
      setDeleteModalId(null);
      console.error("Failed to delete invoice:", err);
    }
  };
  // Example of how you would navigate to the edit page
  const handleEdit = (invoiceId, vendor_id) => {
    localStorage.setItem("vendor_id", vendor_id);
    navigate(`/approver-page/${btoa(btoa(invoiceId))}`, {
      state: { isReadOnly: false }, // You can still pass secondary data
    });
  };

  const handleView = (invoiceId) => {
    //const invoiceId = invoice.id;

    navigate(`/employee/view-invoice-entry/${btoa(btoa(invoiceId))}`, {
      state: { isReadOnly: true }, // Tell the component to be read-only
    });
  };

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    if (pagination) {
      setCurrentPage((prev) => Math.min(prev + 1, pagination?.pages));
    }
  };

  // Filter handlers remain the same
  const handleFilterChange = (setter: (value: any) => void, value: any) => {
    setter(value);
    setCurrentPage(1);
  };
  const handleBtsNoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleFilterChange((val) => setFilterInputs((prev) => ({ ...prev, bts_no: val })), event.target.value);
  };
  const handlePoContractChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleFilterChange((val) => setFilterInputs((prev) => ({ ...prev, po_no: val })), event.target.value);
  };
  const handleInvoiceStatusChange = (selectedStatusValues: string[]) => {
    handleFilterChange((val) => setFilterInputs((prevArgs) => ({ ...prevArgs, invoice_status: val })), selectedStatusValues);
  };
  const handleVendorCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleFilterChange((val) => setFilterInputs((prev) => ({ ...prev, vendor_code: val })), event.target.value);
  };
  const handleVendorNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleFilterChange((val) => setFilterInputs((prev) => ({ ...prev, vendor_name: val })), event.target.value);
  };
  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleFilterChange((val) => setFilterInputs((prev) => ({ ...prev, bill_date: val })), event.target.value);
  };

  const handleApplyFiltersFromModal = () => {
    // setDebouncedFilterInputs(filterInputs); // Apply filters when button is clicked
    setOpenFilterModal(false);
  };


  const onHandleDownloadExcel = () => {
    var query = '?';
    query = query + `user_type=${localStorage.getItem("userRole")}&user_id=${localStorage.getItem("employee_id")}&pernr=${localStorage.getItem("employee_id")}&bts_no=${searchApiArgs?.bts_no}&po_contract=${searchApiArgs?.po_no}&vendor_name=${searchApiArgs?.vendor_name}&vendor_code=${searchApiArgs?.vendor_code}&bill_date=${searchApiArgs?.bill_date}&status=${searchApiArgs?.status}&approval_pending=true`;
    window.open(apiBaseUrl + "/download-invoice-details-employee" + query, "_blank");
  }


  const renderFilters = (isMobile: boolean) => (
    <>
      {/* Your filter JSX remains the same */}
      <FormControl size="sm" sx={isMobile ? { mt: 1 } : { width: "14%" }}>
        <FormLabel>BTS No.</FormLabel>
        <Input placeholder="Search BTS No." startDecorator={<SearchIcon />} value={filterInputs.bts_no} onChange={handleBtsNoChange} />
      </FormControl>
      <FormControl size="sm" sx={isMobile ? { mt: 1 } : { width: "14%" }}>
        <FormLabel>Purchase Order/Contract</FormLabel>
        <Input placeholder="PO/Contract" startDecorator={<SearchIcon />} value={filterInputs.po_no} onChange={handlePoContractChange} />
      </FormControl>
      {!isPendingPage && (
        <Box sx={isMobile ? { mt: 1 } : { width: "14%" }}>
          <MultiSelectCheckboxDropdown
            label="Invoice Status"
            options={invoiceStatusOptionsEmployee}
            selectedValues={filterInputs?.invoice_status || []}
            onChange={handleInvoiceStatusChange}
            placeholder="Filter by status"
            size="sm"
          />
        </Box>
      )}
      <FormControl size="sm" sx={isMobile ? { mt: 1 } : { width: "14%" }}>
        <FormLabel>Vendor Name</FormLabel>
        <Input placeholder="Vendor Name" startDecorator={<SearchIcon />} value={filterInputs.vendor_name} onChange={handleVendorNameChange} />
      </FormControl>
      <FormControl size="sm" sx={isMobile ? { mt: 1 } : { width: "14%" }}>
        <FormLabel>Vendor Code</FormLabel>
        <Input placeholder="Vendor Code" startDecorator={<SearchIcon />} value={filterInputs.vendor_code} onChange={handleVendorCodeChange} />
      </FormControl>
      <FormControl size="sm" sx={isMobile ? { mt: 1 } : { width: "14%" }}>
        <FormLabel>Bill Date</FormLabel>
        <Input startDecorator={<DateRange />} onChange={handleDateChange} type="date" placeholder="dd/mm/yyyy" value={filterInputs.bill_date} />
      </FormControl>


      <FormControl size="sm" sx={isMobile ? { mt: 1 } : { width: "7%" }}>
        <FormLabel>&nbsp;</FormLabel>
        <span>
          {(filterInputs?.bts_no !== "" ||
            filterInputs?.bill_date !== "" ||
            filterInputs?.invoice_status?.length !== 0 ||
            filterInputs?.po_no !== "" ||
            filterInputs?.vendor_code !== "" ||
            filterInputs?.vendor_name !== "") && <Button onClick={clearFilter} sx={{ maxWidth: "fit-content" }} size="sm" variant="soft" color="danger">
              <ClearIcon />
            </Button>}
          {!isPendingPage && <IconButton aria-label="delete" size="lg" onClick={() => onHandleDownloadExcel()} sx={{ minHeight: 'unset', width: '40px', height: '31px' }}>
            <DownloadIcon fontSize="inherit" style={{ transform: 'scale(1.5)' }} />
          </IconButton>}
        </span>
      </FormControl>

    </>
  );

  if (isLoading && !entries) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }


  // ===================================================================
  // === 4. RENDER THE COMPONENT                                     ===
  // ===================================================================
  return (
    <React.Fragment>
      {isPendingPage && `Total Pending Invoices: ${pendingInvoices?.pagination?.total}`}

      <>
        <Sheet
          className="SearchAndFilters-mobile"
          sx={{
            display: { xs: "flex", sm: "none" },
            justifyContent: "flex-end",
            p: 1,
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Button variant="outlined" color="neutral" onClick={() => setOpenFilterModal(true)}>
            Filters
          </Button>
        </Sheet>
        <Modal open={openFilterModal} onClose={() => setOpenFilterModal(false)}>
          <ModalDialog aria-labelledby="filter-modal" layout="center" sx={{ p: 2, width: "calc(100% - 32px)", maxWidth: 400 }}>
            <ModalClose />
            <Typography id="filter-modal" level="h4">
              Filters
            </Typography>
            {/* <Divider sx={{ my: 1 }} /> */}
            <Sheet sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              {renderFilters(true)}
              <Button color="primary" onClick={handleApplyFiltersFromModal} sx={{ mt: 1 }}>
                Apply Filters
              </Button>
            </Sheet>
          </ModalDialog>
        </Modal>
        <Box
          className="SearchAndFilters-tabletUp"
          sx={{
            borderRadius: "sm",
            // pt: 2,
            pb: 1,
            display: { xs: "none", sm: "flex" },
            flexDirection: "row",
            width: "100%",
            flexWrap: "nowrap",
            gap: 1.5,
            "& > *": { minWidth: { xs: "120px", md: "160px" } },
          }}
        >
          {renderFilters(false)}
        </Box>

      </>

      <Sheet
        className="OrderTableContainer"
        variant="outlined"
        sx={{
          width: "100%",
          borderRadius: "sm",
          flexShrink: 1,
          overflow: "auto",
          minHeight: 300,
        }}
      >
        <Table
          aria-labelledby="tableTitle"
          stickyHeader
          hoverRow
          sx={{
            "--TableCell-headBackground": "var(--joy-palette-background-level1)",
            "--Table-headerUnderlineThickness": "1px",
            "--TableRow-hoverBackground": "var(--joy-palette-background-level1)",
          }}
        // borderAxis="both" 
        >
          <thead>
            {/* Table Headers remain the same */}
            <tr>
              <th className="heading-3" style={{
                width: '50px',
                minWidth: '50px',
                padding: "12px 6px",
                textAlign: "center",
              }}>
                <Checkbox
                  checked={selectedList.length === entries?.length}
                  indeterminate={selectedList.length > 0 && selectedList.length < entries?.length}
                  onChange={(e) => onHandleCheckUnCheckAll(e.target)}
                />

              </th>
              {tableHeaders.map((headCell) => (
                <th
                  className="heading-3"
                  key={headCell.id}
                  style={{
                    width: headCell.minWidth,
                    minWidth: headCell.minWidth,
                    padding: "12px 6px",
                    textAlign: "center",
                  }}
                >
                  <Typography fontWeight="lg" level="body-sm">
                    {headCell.label}
                  </Typography>
                  {/* )} */}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {isFetching || isLoadingSearch ? (
              <tr className="fetching">
                <td colSpan={tableHeaders?.length} style={{ textAlign: "center", padding: "16px" }}>
                  <CircularProgress />
                </td>
              </tr>
            ) : entries?.length === 0 ? (
              <tr className="fetching">
                <td colSpan={tableHeaders?.length} style={{ textAlign: "center", padding: "16px" }}>
                  <Typography>
                    No bills found
                    {isSearchActive ? " matching your filters." : "."}
                  </Typography>
                </td>
              </tr>
            ) : (
              entries.map((invoice: any) => (
                <tr key={invoice.id || invoice.bts_no}>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Checkbox
                      checked={selectedList.includes(invoice?.bts_no)}
                      onChange={(e) => onHandleChangeRow(invoice?.bts_no, e.target)}
                    />
                  </td>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{displayOptional(invoice.bts_no)}</Typography>
                  </td>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{displayOptional(invoice?.vendor_name)}</Typography>
                  </td>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{displayOptional(invoice?.vendor_code)}</Typography>
                  </td>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{formatDate(invoice.bts_entry_date)}</Typography>
                  </td>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{displayOptional(invoice.po_no || invoice.po_contract)}</Typography>
                  </td>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{displayOptional(invoice.bill_no)}</Typography>
                  </td>
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{displayOptional(invoice.gem_type)}</Typography>
                  </td>
                  {!isPendingPage && (
                    <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                      <Typography level="body-xs">{displayOptional(invoice?.invoicenumber)}</Typography>
                    </td>
                  )}
                  <td style={{ textAlign: "center", wordBreak: "break-all" }}>
                    <Typography level="body-xs">{formatDate(invoice.bill_date)}</Typography>
                  </td>
                  <td style={{ textAlign: "end" }}>
                    <Typography level="body-xs">{displayOptional(invoice.tax_amount)}</Typography>
                  </td>
                  <td style={{ textAlign: "end" }}>
                    <Typography level="body-xs">{displayOptional(invoice.bill_amount)}</Typography>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <Chip
                      size="sm"
                      variant="soft"
                      color={
                        invoice.status?.toLowerCase().includes("pending")
                          ? "warning"
                          : invoice.status?.toLowerCase().includes("parked") || invoice.status?.toLowerCase().includes("submitted")
                            ? "primary"
                            : invoice.status?.toLowerCase().includes("approved") ||
                              invoice.status?.toLowerCase().includes("accepted") ||
                              invoice.status?.toLowerCase().includes("paid")
                              ? "success"
                              : invoice.status?.toLowerCase().includes("rejected") || invoice.status?.toLowerCase().includes("not parked")
                                ? "danger"
                                : "neutral"
                      }
                    >
                      {displayOptional(invoice.status)}
                    </Chip>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 0.5,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <IconButton size="sm" color="primary" variant="plain" onClick={() => handleView(invoice.bts_no)}>
                        <span title="View">
                          <VisibilityIcon />
                        </span>
                      </IconButton>
                      <IconButton
                        size="sm"
                        color="neutral"
                        variant="plain"
                        onClick={() => handleEdit(invoice.bts_no, invoice.vendor_code)}
                        disabled={isPendingPage ? false : !invoice.status?.toLowerCase().includes("saved_as_draft")}
                      >
                        <span title="Approval">
                          <ApprovalIcon />
                        </span>
                      </IconButton>
                      {!isPendingPage && (
                        <IconButton
                          size="sm"
                          color="danger"
                          variant="plain"
                          disabled={!invoice.status?.toLowerCase().includes("saved_as_draft")}
                          onClick={() => setDeleteModalId(invoice.bts_no)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </Box>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </Sheet>

      {/* Pagination is now safely rendered */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          pt: 0,
        }}
      >
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button size="sm" variant="outlined" onClick={handlePrevPage} disabled={!pagination || pagination?.page <= 1}>
            Previous
          </Button>
          <Typography level="body-sm" sx={{ mx: 1, display: 'flex', alignItems: 'center' }}>
            Page {pagination?.page} of {pagination?.pages}
          </Typography>
          <Button size="sm" variant="outlined" onClick={handleNextPage} disabled={!pagination || pagination?.page >= pagination?.pages}>
            Next
          </Button>

          <Button size="sm" className="btn btn-primary" disabled={selectedList.length === 0} onClick={() => setIsForward(true)}>
            Forward
          </Button>
        </Box>
      </Box>
      <Modal
        open={!!deleteModalId}
        onClose={() => (!deleteInprogress ? setDeleteModalId(null) : null)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            zIndex: 1300,
            bgcolor: "background.surface",
            border: "1px solid",
            borderColor: "neutral.outlinedBorder",
            boxShadow: "lg",
            borderRadius: "md",
            p: 3,
          }}
        >
          <Typography level="h4">Confirm Deletion</Typography>
          <Typography sx={{ mt: 1 }}>Are you sure you want to delete this bill? This action cannot be undone.</Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 1.5,
              mt: 3,
            }}
          >
            <Button variant="outlined" color="neutral" onClick={() => setDeleteModalId(null)} disabled={deleteInprogress}>
              Cancel
            </Button>

            <Button
              variant="solid"
              color="danger"
              loading={deleteInprogress}
              onClick={() => {
                handleDelete(deleteModalId);
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal open={isForward} onClose={() => { setIsForward(false); setForwardTo('') }}>
        <ModalDialog aria-labelledby="filter-modal" layout="center" sx={{ p: 2, width: "calc(100% - 32px)", maxWidth: 400 }}>
          <ModalClose />
          <Typography id="filter-modal" level="h4">
            Forward To
          </Typography>
          {/* <Divider sx={{ my: 1 }} /> */}
          <Sheet sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            <Autocomplete
              placeholder="Choose assign to"
              options={gemInvoiceList}
              sx={{ width: '100%' }}
              onChange={(event, newInputValue) => {
                console.log(newInputValue)
                setForwardTo(newInputValue)
              }}
            />
            <Button disabled={forwardTo.length === 0} onClick={onHendleSendSelectedList}>{isForwarding ? 'Forwarding...' : 'Submit'}</Button>
          </Sheet>
        </ModalDialog>
      </Modal>
    </React.Fragment>
  );
}
